'use strict';

angular.module('orders').factory('TranslationOrder', [
    '$resource',
    function ($resource) {
        return $resource(
            'v1/projects/:mobileAppId/translationOrderGetWordCount',
            {
                mobileAppId: '@mobileAppId',
                orderId: '@orderId',
				languageId: '@languageId',
				groupId: '@groupId',
				submissionId: '@submissionId'
            },
            {
				translationOrderCreateFromApp: {
					url : 'v1/orders/app/:mobileAppId/translationOrderCreateFromApp',
					method:'POST',
					cache: false
				},
				translationOrderCreateFromFile: {
					url : 'v1/orders/app/:mobileAppId/translationOrderCreateFromFile',
					method:'POST',
					cache: false
				},
				translationOrderWordCount: {
					url : 'v1/orders/app/:mobileAppId/translationOrderWordCount',
					method:'Get',
					cache: false
				},
                translationOrderWord: {
                    url : 'v1/orders/app/:mobileAppId/translationOrderWord',
                    method:'Get',
                    cache: false
                },
				getOrder: {
					url : 'v1/orders/:orderId',
					method: 'GET',
					cache: false
				},
				updateOrder: {
					url : 'v1/orders/:orderId',
					method: 'POST',
					cache: false
				},
				cancelOrder: {
					url : 'v1/orders/:orderId',
					method: 'DELETE',
					cache: false
				},
				translationOrderRequest: {
					url : 'v1/orders/:orderId/translationOrderRequest',
					method:'POST',
					cache: false
				},
				getTranslationSettings: {
					url : 'v1/orders/app/:mobileAppId/getTranslationSettings',
					method:'GET',
					cache: true
				},
				getOrders: {
					url : 'v1/orders',
					method:'GET',
					cache: false,
					isArray: true
				},
				sendOrder: {
					url : 'v1/pd/orders/:orderId/sendTranslationOrder',
					method: 'POST',
					cache: false
				},
				translationOrderSubmission: {
					url : 'v1/pd/orders/:orderId/translationOrderSubmission',
					method:'POST',
					cache: false
				},
				saveProductionInfo: {
					url : 'v1/pd/orders/:orderId/saveProductionInfo',
					method:'POST',
					cache: false
				},
				importSubmission: {
					url : 'v1/pd/orders/:orderId/submission/:submissionId/app/:mobileAppId/languages/:languageId/groups/:groupId/importTranslationOrder',
					method: 'POST',
					cache: false
				},
                sendStatusTranslationOrderEmail: {
				    url: '/v1/pd/orders/:orderId/sendStatusTranslationOrderEmail',
                    method: 'POST',
                    cache: false
                },
                countWords: {
                    method: 'POST',
                    url: 'v1/projects/:mobileAppId/countWords',
                    cache: false
                }
            }
        );
    }
]);
